import { useHtmlPersonalization } from '@dai-team/analytics-library'

export function usePersonalizedHtml(personalizedId: string | undefined) {
  return useHtmlPersonalization(personalizedId, true)
}
